<template>
  <div class="space-y-5 divide-y divide-gray-900/10">
    <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-5">
      <div class="px-4 sm:px-0 relative">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Settings</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Specify name and description</p>
        </div>
      </div>

      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
            <div class="sm:col-span-4">
              <label for="name" class="block text-sm font-medium leading-6 text-gray-900">Name</label>
              <div class="mt-2">
                <div class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder="Specify KB Name"
                    v-model="specName"
                  />
                </div>
              </div>
            </div>

            <InputTextarea class="col-span-full" name="description" v-model="specDescription" label="Description" placeholder="Provide brief description of the KB"></InputTextarea>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-6 grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-5">
      <div class="px-4 sm:px-0 relative">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">KPIs</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Choose KPIs collection associated with these categories</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
            <div class="col-span-full">
              <StdPropEditor class="mt-2 col-span-4" :prop-def="propsDefs['kpiCollection']" v-model="kpiCollection" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- todo enable when needed
    <div class="pt-6 grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-5">
      <div class="px-4 sm:px-0 relative">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Advanced</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Show advanced options</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
            <div class="col-span-full">
              <ToggleGroup v-model="advancedEnabled" name="Advanced" description="">
                Advanced props
              </ToggleGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useCategoriesStore } from '@/store/CategoriesStore';
  import InputTextarea from '@/components/Bots/editors/InputTextarea.vue';
  import { CAT_TYPE_DEFS } from '@/spec/CategoriesTypeDefs';
  import StdPropEditor from '@/components/Editors/StdPropEditor.vue';

  const route = useRoute();
  const showAdvanced = computed(() => 'advanced' in (route?.query || {}));
  const categoriesStore = useCategoriesStore();

  const advancedEnabled = ref(false);

  const propsDefs = CAT_TYPE_DEFS['standard']?.propsByName || {};

  const specName = computed(categoriesStore.getCatSpecPropGetSet('name'));
  const specDescription = computed(categoriesStore.getCatSpecPropGetSet('description'));
  const kpiCollection = computed(categoriesStore.getCatSpecPropGetSet('kpiCollection'));
</script>
